
import { defineComponent, PropType } from "vue"
import AclLayout from "@/js/Layouts/Acl.vue"
import { Group } from "@/js/types/user"

// noinspection JSUnusedGlobalSymbols
export default defineComponent({
    name: "ListPage",
    components: { AclLayout },
    props: {
        groups: {
            type: Object as PropType<Group>,
            required: false,
            default: () => ({}),
        },
    },
    methods: {
        deleteGroup(group: Group) {
            if (!group) return
            if (confirm('Вы действительно хотите удалить группу "' + group.name + '"'))
                this.$inertia.delete("/acl/groups/" + group.id)
        },
    },
})
